import 'core-js/modules/es6.regexp.replace.js';
import { tinycolor } from '@ctrl/tinycolor';

/**
 * Accessibility:
 * Takes a color (either as R,G,B or hex #RRGGBB) and gets associated accessible text color.
 */

var getA11yTextColor = function getA11yTextColor(inputColor) {
  var isCustomRGBString = /^\d+,\d+,\d+$/.test(inputColor.replace(/\s+/g, ""));
  var color = isCustomRGBString ? "rgb(".concat(inputColor, ")") : inputColor;
  return tinycolor(color).isLight() ? "black" : "white";
};
/**
 * Get Avatar Color:
 * Takes a given username string and returns a consistent highlight color.
 */

var getAvatarColor = function getAvatarColor(name) {
  var colors = highlights;
  var trimmedName = name.trim();
  var hash = 0;

  for (var i = 0; i < trimmedName.length; i++) {
    hash += trimmedName.charCodeAt(i);
  }

  var color = hash % colors.length;
  return colors[color];
};
/**
 * Colors:
 * Full and extended palette tokens use rgb values
 * without the rgb() function. This allows colors to
 * be used and their opacity changed on the fly.
 */

/* Full Palette */

var colorMidnightBlue1 = "48, 53, 80";
var colorMidnightBlue2 = "77, 85, 128";
var colorMidnightBlue3 = "111, 121, 168";
var colorMidnightBlue4 = "170, 177, 213";
var colorMidnightBlue5 = "203, 208, 230";
var colorMidnightBlue6 = "221, 224, 238";
var colorMidnightBlue7 = "246, 246, 249";
var colorEveningRed1 = "151, 17, 120";
var colorEveningRed2 = "178, 26, 127";
var colorEveningRed3 = "211, 23, 133";
var colorVaricentBlue1 = "8, 31, 145";
var colorVaricentBlue2 = "23, 55, 211";
var colorVaricentBlue3 = "43, 79, 244";
var colorVaricentBlue4 = "226, 233, 254";
var colorVaricentBlue5 = "241, 245, 255";
var colorMorningRed1 = "134, 25, 19";
var colorMorningRed2 = "173, 38, 31";
var colorMorningRed3 = "196, 56, 49";
var colorMorningRed4 = "255, 216, 214";
var colorMorningRed5 = "255, 240, 240";
var colorFieldGreen1 = "19, 78, 83";
var colorFieldGreen2 = "24, 104, 104";
var colorFieldGreen3 = "28, 125, 113";
var colorFieldGreen4 = "217, 238, 236";
var colorFieldGreen5 = "231, 245, 243";
var colorSunlightYellow1 = "153, 102, 0";
var colorSunlightYellow2 = "208, 153, 27";
var colorSunlightYellow3 = "236, 185, 34";
var colorSunlightYellow4 = "250, 241, 194";
var colorSunlightYellow5 = "252, 248, 224";
var colorDuskPurple1 = "97, 14, 162";
var colorDuskPurple2 = "129, 34, 174";
var colorDuskPurple3 = "159, 43, 214";
/* Extended Palette */

var colorDarkGray1 = "8, 8, 8";
var colorDarkGray2 = "24, 24, 24";
var colorDarkGray3 = "40, 40, 40";
var colorDarkGray4 = "56, 56, 56";
var colorDarkGray5 = "72, 72, 72";
var colorGray1 = "88, 88, 88";
var colorGray2 = "104, 104, 104";
var colorGray3 = "120, 120, 120";
var colorGray4 = "136, 136, 136";
var colorGray5 = "152, 152, 152";
var colorLightGray1 = "168, 168, 168";
var colorLightGray2 = "184, 184, 184";
var colorLightGray3 = "216, 216, 216";
var colorLightGray4 = "232, 232, 232";
var colorLightGray5 = "248, 248, 248";
var colorRed1 = "92, 0, 17";
var colorRed2 = "168, 7, 26";
var colorRed3 = "207, 19, 34";
var colorRed4 = "255, 163, 158";
var colorRed5 = "255, 241, 240";
var colorVermilion1 = "97, 11, 0";
var colorVermilion2 = "173, 33, 2";
var colorVermilion3 = "250, 84, 28";
var colorVermilion4 = "255, 187, 150";
var colorVermilion5 = "255, 242, 232";
var colorOrange1 = "97, 37, 0";
var colorOrange2 = "173, 78, 0";
var colorOrange3 = "250, 140, 22";
var colorOrange4 = "255, 213, 145";
var colorOrange5 = "255, 247, 230";
var colorGold1 = "97, 71, 0";
var colorGold2 = "173, 139, 0";
var colorGold3 = "250, 219, 20";
var colorGold4 = "255, 251, 143";
var colorGold5 = "254, 255, 230";
var colorSepia1 = "97, 52, 0";
var colorSepia2 = "174, 104, 0";
var colorSepia3 = "250, 173, 20";
var colorSepia4 = "255, 229, 143";
var colorSepia5 = "255, 251, 230";
var colorLime1 = "27, 66, 0";
var colorLime2 = "56, 158, 13";
var colorLime3 = "142, 221, 0";
var colorLime4 = "228, 255, 120";
var colorLime5 = "251, 255, 227";
var colorGreen1 = "9, 43, 0";
var colorGreen2 = "35, 120, 4";
var colorGreen3 = "82, 196, 26";
var colorGreen4 = "183, 235, 143";
var colorGreen5 = "246, 255, 237";
var colorTurquoise1 = "0, 35, 41";
var colorTurquoise2 = "0, 109, 117";
var colorTurquoise3 = "19, 194, 194";
var colorTurquoise4 = "135, 232, 222";
var colorTurquoise5 = "230, 255, 251";
var colorBlue1 = "0, 39, 102";
var colorBlue2 = "0, 80, 179";
var colorBlue3 = "24, 144, 255";
var colorBlue4 = "145, 213, 255";
var colorBlue5 = "230, 247, 255";
var colorCobalt1 = "3, 8, 82";
var colorCobalt2 = "16, 35, 158";
var colorCobalt3 = "43, 79, 244";
var colorCobalt4 = "173, 198, 255";
var colorCobalt5 = "240, 245, 255";
var colorIndigo1 = "18, 3, 56";
var colorIndigo2 = "57, 16, 133";
var colorIndigo3 = "114, 46, 209";
var colorIndigo4 = "211, 173, 247";
var colorIndigo5 = "249, 240, 255";
var colorRose1 = "82, 3, 57";
var colorRose2 = "158, 16, 104";
var colorRose3 = "235, 47, 150";
var colorRose4 = "255, 173, 210";
var colorRose5 = "255, 240, 246";
/* Text */

var text = "rgb(".concat(colorMidnightBlue2, ")");
var textHeading = "rgb(".concat(colorMidnightBlue1, ")");
var textPlaceholder = "rgb(".concat(colorMidnightBlue4, ")");
var textDisabled = "rgb(".concat(colorLightGray1, ")");
var textInverse = "white";
/* Backgrounds */

var background = "white";
var backgroundMidtone = "rgb(".concat(colorMidnightBlue7, ")");
var backgroundOverlay = "rgba(".concat(colorMidnightBlue1, ", 0.4)");
var backgroundDisabled = "rgb(".concat(colorLightGray4, ")");
var backgroundInverse = "rgb(".concat(colorMidnightBlue1, ")");
/* Borders */

var border = "rgb(".concat(colorMidnightBlue6, ")");
var borderDivider = "rgb(".concat(colorMidnightBlue6, ")");
var borderTable = "rgb(".concat(colorMidnightBlue6, ")");
var borderDisabled = "rgb(".concat(colorLightGray3, ")");
var borderInput = "rgb(".concat(colorMidnightBlue4, ")");
var borderInputHover = "rgb(".concat(colorMidnightBlue3, ")");
var borderInputActive = "rgb(".concat(colorMidnightBlue2, ")");
/* Neutral */

var neutral = "rgb(".concat(colorMidnightBlue3, ")");
var neutralHover = "rgb(".concat(colorMidnightBlue2, ")");
var neutralActive = "rgb(".concat(colorMidnightBlue1, ")");
var neutralTranslucentHover = "rgba(111, 121, 168, 0.15)";
var neutralTranslucentActive = "rgba(111, 121, 168, 0.3)";
/* Accent */

var accent = "rgb(".concat(colorEveningRed3, ")");
var accentHover = "rgb(".concat(colorEveningRed2, ")");
var accentActive = "rgb(".concat(colorEveningRed1, ")");
var accentTranslucentHover = "rgba(220, 106, 173, 0.15)";
var accentTranslucentActive = "rgba(202, 114, 165, 0.3)";
/* Intents */

var intentPrimary = "rgb(".concat(colorVaricentBlue3, ")");
var intentPrimaryHover = "rgb(".concat(colorVaricentBlue2, ")");
var intentPrimaryActive = "rgb(".concat(colorVaricentBlue1, ")");
var intentPrimaryTranslucentHover = "rgba(163, 189, 255, 0.15)";
var intentPrimaryTranslucentActive = "rgba(157, 182, 251, 0.3)";
var intentSuccess = "rgb(".concat(colorFieldGreen3, ")");
var intentSuccessHover = "rgb(".concat(colorFieldGreen2, ")");
var intentSuccessActive = "rgb(".concat(colorFieldGreen1, ")");
var intentSuccessTranslucentHover = "rgba(88, 187, 173, 0.149)";
var intentSuccessTranslucentActive = "rgba(123, 198, 189, 0.3)";
var intentWarning = "rgb(".concat(colorSunlightYellow3, ")");
var intentWarningHover = "rgb(".concat(colorSunlightYellow2, ")");
var intentWarningActive = "rgb(".concat(colorSunlightYellow1, ")");
var intentWarningTranslucentHover = "rgba(238, 208, 51, 0.15)";
var intentWarningTranslucentActive = "rgba(238, 208, 51, 0.3)";
var intentDanger = "rgb(".concat(colorMorningRed3, ")");
var intentDangerHover = "rgb(".concat(colorMorningRed2, ")");
var intentDangerActive = "rgb(".concat(colorMorningRed1, ")");
var intentDangerTranslucentHover = "rgba(255, 159, 154, 0.15)";
var intentDangerTranslucentActive = "rgba(255, 126, 119, 0.3)";
/* Highlights */

var highlight01 = "rgb(74, 40, 113)";
var highlight01Translucent = "rgba(74, 40, 113, 0.1)";
var highlight02 = "rgb(15, 67, 127)";
var highlight02Translucent = "rgba(15, 67, 127, 0.1)";
var highlight03 = "rgb(2, 117, 88)";
var highlight03Translucent = "rgba(2, 117, 88, 0.1)";
var highlight04 = "rgb(124, 103, 18)";
var highlight04Translucent = "rgba(124, 103, 18, 0.1)";
var highlight05 = "rgb(150, 44, 141)";
var highlight05Translucent = "rgba(150, 44, 141, 0.1)";
var highlight06 = "rgb(4, 109, 144)";
var highlight06Translucent = "rgba(4, 109, 144, 0.1)";
var highlight07 = "rgb(66, 94, 46)";
var highlight07Translucent = "rgba(66, 94, 46, 0.1)";
var highlight08 = "rgb(156, 87, 52)";
var highlight08Translucent = "rgba(156, 87, 52, 0.1)";
var highlight09 = "rgb(122, 31, 88)";
var highlight09Translucent = "rgba(122, 31, 88, 0.1)";
var highlight10 = "rgb(100, 82, 161)";
var highlight10Translucent = "rgba(100, 82, 161, 0.1)";
var highlight11 = "rgb(3, 87, 94)";
var highlight11Translucent = "rgba(3, 87, 94, 0.1)";
var highlight12 = "rgb(117, 72, 19)";
var highlight12Translucent = "rgba(117, 72, 19, 0.1)";
var highlights = [highlight01, highlight02, highlight03, highlight04, highlight05, highlight06, highlight07, highlight08, highlight09, highlight10, highlight11, highlight12];
var highlightsTranslucent = [highlight01Translucent, highlight02Translucent, highlight03Translucent, highlight04Translucent, highlight05Translucent, highlight06Translucent, highlight07Translucent, highlight08Translucent, highlight09Translucent, highlight10Translucent, highlight11Translucent, highlight12Translucent];
/* Focus */

var focus = "rgb(".concat(colorDuskPurple3, ")");
/* Swatch Lists */

var swatchList01 = ["#".concat(tinycolor("rgb(".concat(colorVermilion3, ")")).toHex()), "#".concat(tinycolor("rgb(".concat(colorSepia3, ")")).toHex()), "#".concat(tinycolor("rgb(".concat(colorGreen3, ")")).toHex()), "#".concat(tinycolor("rgb(".concat(colorTurquoise3, ")")).toHex()), "#".concat(tinycolor("rgb(".concat(colorBlue3, ")")).toHex()), "#".concat(tinycolor("rgb(".concat(colorIndigo3, ")")).toHex()), "#".concat(tinycolor("rgb(".concat(colorGray3, ")")).toHex()), "#".concat(tinycolor("black").toHex()), "#".concat(tinycolor("rgb(".concat(colorVermilion4, ")")).toHex()), "#".concat(tinycolor("rgb(".concat(colorSepia4, ")")).toHex()), "#".concat(tinycolor("rgb(".concat(colorGreen4, ")")).toHex()), "#".concat(tinycolor("rgb(".concat(colorTurquoise4, ")")).toHex()), "#".concat(tinycolor("rgb(".concat(colorBlue4, ")")).toHex()), "#".concat(tinycolor("rgb(".concat(colorIndigo4, ")")).toHex()), "#".concat(tinycolor("rgb(".concat(colorLightGray4, ")")).toHex()), "#".concat(tinycolor("white").toHex())];
/**
 * Border Radius
 */

var borderRadiusExtraSmall = "0.125rem";
var borderRadiusSmall = "0.25rem";
var borderRadiusMedium = "0.5rem";
var borderRadiusLarge = "0.75rem";
var borderRadiusFull = "100px";
/**
 * Elevation
 */

var elevation0 = "0 0 0 1px ".concat(colorMidnightBlue6);
var elevation1 = "0 0 0 1px rgba(".concat(colorDuskPurple1, ", 0.03), 0 0.25rem 0.375rem rgba(").concat(colorDuskPurple1, ", 0.12)");
var elevation2 = "0 0 0 1px rgba(".concat(colorDuskPurple1, ", 0.03), 0 0.5rem 0.625rem rgba(").concat(colorDuskPurple1, ", 0.12)");
var elevation3 = "0 0 0 1px rgba(".concat(colorDuskPurple1, ", 0.03), 0 1rem 1.125rem rgba(").concat(colorDuskPurple1, ", 0.12)");
var elevation4 = "0 0 0 1px rgba(".concat(colorDuskPurple1, ", 0.03), 0 2.25rem 3rem rgba(").concat(colorDuskPurple1, ", 0.12)");
/**
 * Max Widths
 */

var maxWidthContent = "40.5rem";
/**
 * Media Query Break Points
 */

/* Desktop First: Large is default */

var breakpointMaxMedium = "960px";
var breakpointMaxSmall = "768px";
var breakpointMaxExtraSmall = "600px";
/* Mobile First: Extra small is default */

var breakpointMinSmall = "601px";
var breakpointMinMedium = "769px";
var breakpointMinLarge = "961px";

export { accent, accentActive, accentHover, accentTranslucentActive, accentTranslucentHover, background, backgroundDisabled, backgroundInverse, backgroundMidtone, backgroundOverlay, border, borderDisabled, borderDivider, borderInput, borderInputActive, borderInputHover, borderRadiusExtraSmall, borderRadiusFull, borderRadiusLarge, borderRadiusMedium, borderRadiusSmall, borderTable, breakpointMaxExtraSmall, breakpointMaxMedium, breakpointMaxSmall, breakpointMinLarge, breakpointMinMedium, breakpointMinSmall, colorBlue1, colorBlue2, colorBlue3, colorBlue4, colorBlue5, colorCobalt1, colorCobalt2, colorCobalt3, colorCobalt4, colorCobalt5, colorDarkGray1, colorDarkGray2, colorDarkGray3, colorDarkGray4, colorDarkGray5, colorDuskPurple1, colorDuskPurple2, colorDuskPurple3, colorEveningRed1, colorEveningRed2, colorEveningRed3, colorFieldGreen1, colorFieldGreen2, colorFieldGreen3, colorFieldGreen4, colorFieldGreen5, colorGold1, colorGold2, colorGold3, colorGold4, colorGold5, colorGray1, colorGray2, colorGray3, colorGray4, colorGray5, colorGreen1, colorGreen2, colorGreen3, colorGreen4, colorGreen5, colorIndigo1, colorIndigo2, colorIndigo3, colorIndigo4, colorIndigo5, colorLightGray1, colorLightGray2, colorLightGray3, colorLightGray4, colorLightGray5, colorLime1, colorLime2, colorLime3, colorLime4, colorLime5, colorMidnightBlue1, colorMidnightBlue2, colorMidnightBlue3, colorMidnightBlue4, colorMidnightBlue5, colorMidnightBlue6, colorMidnightBlue7, colorMorningRed1, colorMorningRed2, colorMorningRed3, colorMorningRed4, colorMorningRed5, colorOrange1, colorOrange2, colorOrange3, colorOrange4, colorOrange5, colorRed1, colorRed2, colorRed3, colorRed4, colorRed5, colorRose1, colorRose2, colorRose3, colorRose4, colorRose5, colorSepia1, colorSepia2, colorSepia3, colorSepia4, colorSepia5, colorSunlightYellow1, colorSunlightYellow2, colorSunlightYellow3, colorSunlightYellow4, colorSunlightYellow5, colorTurquoise1, colorTurquoise2, colorTurquoise3, colorTurquoise4, colorTurquoise5, colorVaricentBlue1, colorVaricentBlue2, colorVaricentBlue3, colorVaricentBlue4, colorVaricentBlue5, colorVermilion1, colorVermilion2, colorVermilion3, colorVermilion4, colorVermilion5, elevation0, elevation1, elevation2, elevation3, elevation4, focus, getA11yTextColor, getAvatarColor, highlight01, highlight01Translucent, highlight02, highlight02Translucent, highlight03, highlight03Translucent, highlight04, highlight04Translucent, highlight05, highlight05Translucent, highlight06, highlight06Translucent, highlight07, highlight07Translucent, highlight08, highlight08Translucent, highlight09, highlight09Translucent, highlight10, highlight10Translucent, highlight11, highlight11Translucent, highlight12, highlight12Translucent, highlights, highlightsTranslucent, intentDanger, intentDangerActive, intentDangerHover, intentDangerTranslucentActive, intentDangerTranslucentHover, intentPrimary, intentPrimaryActive, intentPrimaryHover, intentPrimaryTranslucentActive, intentPrimaryTranslucentHover, intentSuccess, intentSuccessActive, intentSuccessHover, intentSuccessTranslucentActive, intentSuccessTranslucentHover, intentWarning, intentWarningActive, intentWarningHover, intentWarningTranslucentActive, intentWarningTranslucentHover, maxWidthContent, neutral, neutralActive, neutralHover, neutralTranslucentActive, neutralTranslucentHover, swatchList01, text, textDisabled, textHeading, textInverse, textPlaceholder };
//# sourceMappingURL=theme.js.map
